import React from 'react';
import useDropdownHelper, { DefaultDropdownProps, DropdownOption, Option } from './dropdownHelper';
import { useUiTheme } from 'framework/uiTheme';
import { CommonInputLayoutProps } from './types';
import { SelectComponentsConfig } from 'react-select';

export interface DefaultDropdownLayoutProps<OptionsType = DropdownOption[]> extends CommonInputLayoutProps<any> {
  options?: OptionsType;
  multiple?: boolean;
  filterOption?: (option: { data: Option }, rawInput: string) => boolean;
  formatOptionLabel?: (
    data: Option,
    formatOptionLabelMeta: {
      context: 'menu' | 'value';
    },
  ) => React.ReactNode;
  styles?: Dictionary<any>;
  components?: SelectComponentsConfig<any, any, any>;
  isLoading?: boolean;
  disabled?: any;
  hasFilterByLabel?: boolean;
  [key: string]: any;
}

export type DefaultDropdownLayoutType = ReactComponent<DefaultDropdownLayoutProps>;

const Dropdown = <ValueType extends string | number | string[]>(
  props: DefaultDropdownProps<DropdownOption[], ValueType>,
) => {
  const { DropdownLayout } = useUiTheme<DefaultDropdownLayoutType>();
  const dropdownHelper = useDropdownHelper(props);

  return (
    <DropdownLayout
      {...props}
      isVisible={dropdownHelper.isVisible()}
      label={dropdownHelper.getLabel()}
      source={dropdownHelper.getSource()}
      onChangeCallback={
        dropdownHelper.isMultiple()
          ? dropdownHelper.getMultipleOnChangeCallback()
          : dropdownHelper.getOnChangeCallback()
      }
      onBlurCallback={dropdownHelper.getValidationCallback()}
      onFocusCallback={dropdownHelper.getClearValidationCallback()}
      value={dropdownHelper.getValue()}
      errorMessages={dropdownHelper.getErrorMessages()}
      isRequired={dropdownHelper.getIsRequired()}
      options={dropdownHelper.getSelectOptions()}
      multiple={dropdownHelper.isMultiple()}
      disabled={dropdownHelper.getIsDisabled()}
      placeholder={dropdownHelper.getPlaceholder()}
      tooltip={dropdownHelper.getTooltip()}
      helpText={dropdownHelper.getHelpText()}
      className={dropdownHelper.getClassName()}
    />
  );
};

export default Dropdown;
